export default __webpack_public_path__ + "static/media/plus-circle.a8b6def2.svg";